import * as types from './types';

const initialState = {
    dailies: [],
    dailies_infos: {},
    filters: {}
};

const statsReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_STATS_FILTERS_SUCCESS: {
            return {
                ...state,
                filters: action.payload.filters,
            };
        }

        case types.GET_DAILY_STATS_SUCCESS: {
            return {
                ...state,
                dailies: action.payload.stats,
                dailies_infos: action.payload.infos || {},
            };
        }

        default:
            return state;
    }
};

export default statsReducer;
